import {useEffect, useState} from "react";

export const Init = () => {
    const [chatReady, setChatReady] = useState('❌');
    const [trilemmaReady, setTrilemmaReady] = useState('❌');
    const [chaosCharactersReady, setChaosCharactersReady] = useState('❌');
    const [allegedlyTrueReady, setAllegedlyTrueReady] = useState('❌');
    const [dancelestrationsReady, setDancelestrationsReady] = useState('❌');
    const [makeItADanceReady, setMakeItADanceReady] = useState('❌');
    const [openingNarrationReady, setOpeningNarrationReady] = useState('❌');
    const [readyStatus, setReadyStatus] = useState({ready: 0, total: 0, not_ready: []});

    useEffect(() => {
        const fetchStatus = () => {
            fetch('/users/ready-status').then(r => r.json()).then(setReadyStatus).catch(() => {});
        };
        fetchStatus();
        const id = setInterval(fetchStatus, 3000);
        return () => clearInterval(id);
    }, []);

    const initAll = () => {
        // fetch('/button-pusher/init').then(() => {});
        // fetch('/drawing-story/init', {cache: "no-store"}).then(() => {});
        // fetch('/dance-battle/init').then(() => {});
        // init('/mind-read/init', setMindReadReady);
        init('/chat/init', setChatReady);
        init('/trilemma/init', setTrilemmaReady);
        init('/chaos-characters/init', setChaosCharactersReady);
        init('/dancelestrations/init', setDancelestrationsReady);
        init('/make-it-a-dance/init', setMakeItADanceReady);
        // Pre-warm the opening AiDialog narration. Hitting /get-quips
        // generates + caches the response; subsequent scene-time fetches
        // return instantly. Takes 30-60s.
        init('/character-creator/get-quips', setOpeningNarrationReady);
    }

    const initAllegedlyTrue = () => {
        init('/allegedly-true/init', setAllegedlyTrueReady);
    }

    const init = (path, setter) => {
        setter('🕚')

        fetch(path).then((response) => {
            if (response.ok) setter('✅');
            else setter('❌');
        }).catch(() => {
            setter('❌');
        });
    }

    return <div className="evenly-distribute">
        <div>
            <button style={{fontSize: 80}} onClick={() => initAll()}>Init</button>
            <div style={{fontSize: 28, marginTop: 12, color: '#36ff36'}}>
                {readyStatus.ready} / {readyStatus.total} ready
            </div>
            {readyStatus.not_ready.length > 0 && (
                <div style={{fontSize: 16, marginTop: 6, opacity: 0.7, maxWidth: 320}}>
                    Not ready: {readyStatus.not_ready.join(', ')}
                </div>
            )}
            <button style={{fontSize: 32, marginTop: 20, display: 'block'}} onClick={() => initAllegedlyTrue()}>Init Allegedly True</button>
            <a href="/allegedly-true-curate" style={{display: 'block', fontSize: 24, marginTop: 12, color: '#36ff36'}}>Curate Allegedly True →</a>
        </div>
        <div>
            <div style={{fontSize: 34}}>{chatReady} Chat</div>
            <div style={{fontSize: 34}}>{trilemmaReady} Trilemma</div>
            <div style={{fontSize: 34}}>{chaosCharactersReady} Chaos Characters</div>
            <div style={{fontSize: 34}}>{allegedlyTrueReady} Allegedly True</div>
            <div style={{fontSize: 34}}>{dancelestrationsReady} Dancelestrations</div>
            <div style={{fontSize: 34}}>{makeItADanceReady} Make It A Dance</div>
            <div style={{fontSize: 34}}>{openingNarrationReady} Opening Narration</div>
        </div>
    </div>
}